/* eslint no-console: off */
import { useState } from 'react';
import { useRouter } from 'next/router';
import LoginForm from '../../src/components/LoginForm';
import RegisterForm from '../../src/components/RegisterForm';
import ClientLayout from '../../src/layouts/client/ClientLayout';
import MetaHeader from '../../src/components/MetaHeader';
import withAuthSyncMember from '../../utils/withAuthSyncMember';
import BookingConfirmBanner from '../../src/assets/images/background/booking-confirm-bg.png';
import checkIsLineBrowser from '../../utils/checkIsLineBrowser';
import { textConfig } from '../../constants/textLang';

export const RegisterPageComponent = (props) => {
    const { isLineBrowser, liffProfile, callbackToLiff } = props;
    const router = useRouter();
    // state zone
    const TABS = {
        default: 'login_tab',
        login: 'login_tab',
        register: 'register_tab',
    };
    const [tab, setTab] = useState(TABS.default);

    const setCurrentTab = (tab) => {
        setTab(tab);
    };

    const getClassName = (isActive) => {
        return isActive ? 'tab active' : 'tab';
    };

    const callbackToken = (d) => {
        if (d?.access_token) {
            if (!isLineBrowser) {
                router.replace('/member/profile');
            } else {
                if (typeof callbackToLiff === 'function') {
                    callbackToLiff(true);
                }
            }
        }
    };

    return (
        <main
            className="register-page"
            style={{
                backgroundImage: `url(${BookingConfirmBanner.src})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            }}
        >
            <div className="register-form">
                <div className="tab-wrapper">
                    <div className={`${getClassName(tab === TABS.login)}`}>
                        <button
                            type="button"
                            onClick={() => setCurrentTab(TABS.login)}
                        >
                            Already Member
                        </button>
                    </div>
                    <span className={`${getClassName(tab === TABS.register)}`}>
                        <button
                            type="button"
                            onClick={() => setCurrentTab(TABS.register)}
                        >
                            New Member
                        </button>
                    </span>
                </div>
                {tab === TABS.login && (
                    <LoginForm
                        callbackToken={callbackToken}
                        liffProfile={liffProfile || {}}
                        isLineBrowser={isLineBrowser || false}
                    />
                )}
                {tab === TABS.register && (
                    <RegisterForm
                        callbackToken={callbackToken}
                        liffProfile={liffProfile || {}}
                        isLineBrowser={isLineBrowser || false}
                    />
                )}
            </div>
        </main>
    );
};

const Register = (props) => {
    const [isLineBrowser, setIsLineBrowser] = useState(false);
    const [liffProfile, setLiffProfile] = useState({});
    const [loading, setLoading] = useState(true);

    const callbackData = (data) => {
        if (data.is_line_browser) {
            setLiffProfile(data.liff_profile);
            setIsLineBrowser(data.is_line_browser);
            setLoading(data.loading);
        } else {
            setLoading(data.loading);
        }
    };

    return (
        <ClientLayout liffId={props.liffId} callbackData={callbackData}>
            {!loading && (
                <RegisterPageComponent
                    isLineBrowser={isLineBrowser}
                    liffProfile={liffProfile}
                />
            )}
        </ClientLayout>
    );
};

export const getServerSideProps = async (context) => {
    const authSync = await withAuthSyncMember(context, 'member/register');
    const { locale } = context
    if (authSync?.redirect) {
        return {
            redirect: {
                ...authSync.redirect,
            },
        };
    }
    const meta = {
        title: textConfig[locale]?.title_regsiter,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Register',
        image: 'main-pic.jpeg'
    };
    const liffId = process?.env?.VIP29_REGISTER_LIFF_ID || null;
    return {
        props: { ...authSync.props, meta, liffId },
    };
};

export default MetaHeader(Register);
